import { TEMPLATE_PRESETS } from '../../../../constants/templatePresets';
import {
  NEW_BANNER_BASE64,
  NEW_EVENT_TICKET_BANNER_BASE64,
  NEW_ICON_BASE64,
  NEW_LOGO_BASE64,
} from '../../../../utils/base64';

const collectImageValues = (root: unknown, bucket: Set<string>) => {
  const stack: unknown[] = [root];
  const visited = new Set<object>();

  while (stack.length > 0) {
    const value = stack.pop();
    if (!value) continue;
    if (typeof value === 'string') {
      bucket.add(value);
      continue;
    }
    if (typeof value !== 'object') continue;
    if (visited.has(value)) continue;
    visited.add(value);

    Object.entries(value as Record<string, unknown>).forEach(([key, child]) => {
      if (key === 'watermark') return;
      stack.push(child);
    });
  }
};

const buildStockDesignImages = () => {
  const images = new Set<string>([
    NEW_LOGO_BASE64,
    NEW_ICON_BASE64,
    NEW_BANNER_BASE64,
    NEW_EVENT_TICKET_BANNER_BASE64,
  ]);

  TEMPLATE_PRESETS.forEach((preset) => {
    const data = preset.template_data as {
      images?: unknown;
      stampCard?: { stamps?: unknown };
    };
    collectImageValues(data.images, images);
    collectImageValues(data.stampCard?.stamps, images);
  });

  return images;
};

const STOCK_DESIGN_IMAGES = buildStockDesignImages();

export const isStockDesignImage = (image?: string | null) =>
  !!image && STOCK_DESIGN_IMAGES.has(image);
